import {FuelLevelModel} from './fuel-level.model';
import {ChargeLineDTOModel} from './charge-lineDTO.model';
import {PtserialBeansModel} from './ptserial-beans.model';
import { Injectable } from "@angular/core";
import { BundleItemModel } from './bundle-item.model';

@Injectable()
export class DetaillineDTOModel {
    public id: number;
    public pdesc: string;
    public packageName: string;
    public packageSeq: number;
    public lineNumber: number;
    public reg: string;
    public plu: string;
    public description: string;
    public weeklyRate: number;
    public qty: number;
    public fromDate: string;
    public toDate: string;
    public startDate: string; // Used for buffered stock
    public comment: string;
    public documentLineNumber: number;
    public serial: string;
    public detailLineId: number;
    public documentNumber: number;
    public contractDocumentNumber: number;
    public location: number;
    public fuelLevel: FuelLevelModel;
    public overrideDescriptionNote: string;
    public stat: number;
    public changeOverDetailLine: DetaillineDTOModel;
    public originalDetailLine: DetaillineDTOModel;
    public originalDetailLineBackup: DetaillineDTOModel;
    public custLocation: any;
    public length: number;
    public width: number;
    public height: number;
    public plantOrProductId: number;
    public timeCharged: number;
    public chargePeriod: string;
    public goods: number;
    public vat: number;
    public total: number;
    public discount: number;
    public chargeLine: ChargeLineDTOModel;
    public vRate: number;
    public custId: number; // needed for calculaterental service
    public sparesWsJobTasksId: number;
    public typ: string;
    public barcode: string;
    public ptSerialBeans: PtserialBeansModel[];
    public transportProductType: boolean;
    public fuelProductType: boolean;
    public patientId: string;
    public site: number;
    public supplierRef: string;
    public binLocation: string;
    public physicalStock: number;
    public onOrderStock: number;
    public plantNumber: string;
    public bundleItems: BundleItemModel[];
    [x: string]: any;
}
